import type * as React from "react";
import type { Color } from "../../lib/colors";
import type { Omittable } from "../../lib/props";
import { Box } from "./box";

/**
 * A small filled circle in a color: a live-status mark beside a label, a
 * legend swatch, an unread marker. The color rides the same `data-color`
 * scale every other colored mark uses, so a status dot and the chip naming
 * the status share one hue.
 */
export function Dot({
  color,
  size = 8,
}: Omittable<{
  color: Color;
  /** Diameter in px. */
  size?: number;
}>): React.ReactElement {
  return (
    <Box
      className="bg-c"
      data-color={color}
      data-slot="dot"
      height={size}
      rounded="full"
      shrink={false}
      width={size}
    />
  );
}
